import { Grid, Paper } from "@mui/material";
import React, { useState } from "react";
import CustomModal from "../components/Dialog";
import Fab from "../components/Fab";
import AddNote from "./addNote";
import useToken from "../hooks/useToken";
import roles from "../constants/roles";
import { dateFormat } from "../screens/common";

function NoteList({
  sampleId = "",
  notesById = "",
  setNotes,
  netsuiteId = "",
  requestType = "",
  createNoteAccess = true,
  order_id = null
}) {
  const notes = notesById;
  const [open, setOpen] = useState(false);
  const { getCurrentUserDetails } = useToken();
  const currentUserDetails = getCurrentUserDetails();
  const currentUserRole = currentUserDetails?.role;
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  function createNote() {
    return currentUserRole !== roles.Auditor && createNoteAccess;
  }
  return (
    <>
      <Grid container direction="row" spacing={2}>
        <Grid xs={6} item></Grid>
        {createNote() && (
          <Grid
            xs={6}
            item
            justifyContent="flex-end"
            alignItems="center"
            style={{ display: "flex" }}
          >
            <Fab label={"Add Note"} variant="extended" onClick={handleOpen} />
          </Grid>
        )}
        <Grid item xs={12} md={12}>
          {notes &&
            notes.map((note) => (
              <>
                {note.title && (
                  <Grid container spacing={1}>
                    <Grid item xs={12} md={12} style={{ marginBottom: "10px" }}>
                      <Paper style={{ backgroundColor: "#f5f5f5" }}>
                        <div style={{ paddingLeft: "10px", paddingTop: "6px" }}>
                          <b>{note.title}</b>
                        </div>
                        <div
                          style={{
                            paddingLeft: "10px",
                            paddingTop: "6px",
                            whiteSpace: "pre-wrap",
                          }}
                        >
                          {note.description} &nbsp;
                          <span
                            style={{
                              display: "block",
                              textAlign: "right",
                              fontSize: "small",
                              paddingRight: "10px",
                            }}
                          >
                            {note.createdBy} &nbsp;
                            {dateFormat(
                              new Date(note.createdAt),
                              "DD/MM/YY H:mma"
                            )}
                          </span>
                        </div>
                      </Paper>
                    </Grid>
                  </Grid>
                )}
              </>
            ))}
        </Grid>
      </Grid>
      <CustomModal
        title="Add Note"
        openModal={open}
        closeModal={handleClose}
        body={
          <AddNote
            sampleId={sampleId}
            setNotes={setNotes}
            notes={notesById}
            netsuiteid={netsuiteId}
            requestType={requestType}
            closeModal={handleClose}
            label="Note"
            order_id={order_id}
          />
        }
      />
    </>
  );
}

export default NoteList;
